/*
 * Form messages
 *
 * This contains all the common text for the Form components
 *
 * NOTE: This is used components/Address as well
 * TODO: Move Address components into components/Forms, or split this file up
 * per component
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  firstName: {
    id: 'common.forms.firstName',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'common.forms.lastName',
    defaultMessage: 'Last name',
  },
  country: {
    id: 'common.forms.country',
    defaultMessage: 'Country',
  },
  company: {
    id: 'common.forms.company',
    defaultMessage: 'Company',
  },
  addressLineOne: {
    id: 'common.forms.addressLineOne',
    defaultMessage: 'Address Line 1',
  },
  addressLineTwo: {
    id: 'common.forms.addressLineTwo',
    defaultMessage: 'Address Line 2',
  },
  postalCode: {
    id: 'common.forms.postalCode',
    defaultMessage: 'Postal code',
  },
  city: {
    id: 'common.forms.city',
    defaultMessage: 'City',
  },
  phone: {
    id: 'common.forms.phone',
    defaultMessage: 'Phone',
  },
  sameShipping: {
    id: 'common.forms.sameShipping',
    defaultMessage: 'Same as shipping address',
  },
  optional: {
    id: 'common.forms.optional',
    defaultMessage: 'Optional',
  },
});
